import { render, staticRenderFns } from "./AdminActivityGroupConfirmDeleteModal.vue?vue&type=template&id=8ed677f2&"
import script from "./AdminActivityGroupConfirmDeleteModal.vue?vue&type=script&lang=js&"
export * from "./AdminActivityGroupConfirmDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports